import React from "react";
import { STATUS, DEFAULT_STATUS } from "utils/constants";

import PropTypes from "prop-types";

const Status = ({ status, text, icon }) => {
  return (
    <div className={`status__wrap ${status}--variant`}>
      {icon}
      <span> {text}</span>
    </div>
  );
};

Status.propTypes = {
  text: PropTypes.string.isRequired,
  status: PropTypes.oneOf(STATUS),
};

Status.defaultProps = {
  status: DEFAULT_STATUS,
};

export default Status;
